import get from "lodash/get";

// helpers
import getVideoPreviews from "@/helpers/getVideoPreviews";

// interfaces
import { ISingleLocationResponse } from "@/types/api/SingleLocationResponse";
import { ILocationSpaceCarousel } from "@/containers/LocationSpaceCarousel/ILocationSpaceCarousel";
import { IFloor } from "@/types/Space";


type TPictures = {
  image: { url: string },
  location: number,
  priority: number,
  id: number,
  imageUrl: string
}

export const initPreviewData = (locationPreview: string | null): ISingleLocationResponse => {
  if (!locationPreview) {
    return {} as unknown as ISingleLocationResponse;
  }

  const previewData = JSON.parse(locationPreview as string);

  if (!previewData) {
    return {} as unknown as ISingleLocationResponse;
  }

  return ({
    ...previewData,
    floors: (previewData.floors as IFloor[]).map((floor, index) => ({ ...floor, id: index })),
    demographic: { ...previewData.demographic, },
    pictures: (previewData.pictures as TPictures[]).map(({ id, imageUrl }) => ({ id, original: imageUrl })),
    picturesCustomOrdering: previewData.pictures,
  });
};

export const transformLocationImages = async (data: ISingleLocationResponse) => {
  const locationImagesToSet = [];

  if (data && data.picturesCustomOrdering) {
    const locationImagesSorted = (data.picturesCustomOrdering || [])
      .map(item => {

        return {
          src: get(item, "thumbnailImage.url") || get(item, "image.url"),
          previewSrc: get(item, "image.url"),
          alt: data.metaTitle || data.name,
          priority: item.priority
        };
      })
      .filter(item => !!item.src)
      .sort((currentItem, nextItem) => currentItem.priority - nextItem.priority);

    locationImagesToSet.push(...locationImagesSorted);
  }

  if (data && data.videos) {
    const videoPreviews = await getVideoPreviews(data.videos as unknown as { url: string; }[]).catch(() => null);

    locationImagesToSet.push(...(videoPreviews || []));
  }

  return locationImagesToSet as ILocationSpaceCarousel["items"];
};
